"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EKeyCodes;

(function (EKeyCodes) {
  EKeyCodes[EKeyCodes["SpaceBar"] = 32] = "SpaceBar";
  EKeyCodes[EKeyCodes["PageUp"] = 33] = "PageUp";
  EKeyCodes[EKeyCodes["PageDown"] = 34] = "PageDown";
  EKeyCodes[EKeyCodes["End"] = 35] = "End";
  EKeyCodes[EKeyCodes["Home"] = 35] = "Home";
  EKeyCodes[EKeyCodes["Left"] = 37] = "Left";
  EKeyCodes[EKeyCodes["Up"] = 38] = "Up";
  EKeyCodes[EKeyCodes["Right"] = 39] = "Right";
  EKeyCodes[EKeyCodes["Down"] = 40] = "Down";
})(EKeyCodes = exports.EKeyCodes || (exports.EKeyCodes = {}));